// extracted by mini-css-extract-plugin
export default {"value":"ButtonSlider__value--U4y6q","wrapper":"ButtonSlider__wrapper--jUmV0","handle":"ButtonSlider__handle--dJ9e3","track":"ButtonSlider__track--uWlc9"};